// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bao_a"};